// extracted by mini-css-extract-plugin
export default {"text":"NoDeviceOnThing_text__i40NH","add_device_container":"NoDeviceOnThing_add_device_container__p0IGT"};